import usePrivateAxios from '@/common/api/usePrivateAxios'
import { unFormatCurrency } from '@/common/utils/unFormatters'
import { UpdateGovernmentAllocationApprovedValueSchema } from '@/features/privateCompanies/schemas/updateGovernmentAllocationApprovedValue.schema'
import { useMutation } from '@tanstack/react-query'

type UpdateGovernmentAllocationApprovedValueProps = {
  governmentAllocationId?: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useUpdateGovernmentAllocationApprovedValue = ({
  governmentAllocationId,
  onSuccess,
  onError,
}: UpdateGovernmentAllocationApprovedValueProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateGovernmentAllocationApprovedValue', governmentAllocationId],
    mutationFn: async (form: UpdateGovernmentAllocationApprovedValueSchema) => {
      const payload = {
        approved_value: unFormatCurrency(form.approved_value),
      }

      return privateAxios.put(
        `/billing/government_allocations/${governmentAllocationId}/change_approved_value`,
        payload,
      )
    },
    onSuccess,
    onError,
  })
}
